/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import Assignments from 'bundles/epic/data/defaults/Assignments.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  enablePreventAddingNewQuizzes: boolean;
  preventAddingNewQuizzesRolloutConfig: any;
  enableAiQuestionGenerator: boolean;
  aiQuestionGeneratorRolloutConfig: any;
  enableReusableAssignmentQuestionBanks: boolean;
  enableQuizMigrationPhase1: boolean;
  enableQuestionRater: boolean;
  enableAssessmentGeneratorPhase4: boolean;
  agPhase4RolloutConfig: any;
  enableAssessmentGeneratorPhase5: boolean;
  agPhase5CourseNames: any;
  alwaysExcludeFromAssessmentGeneration: any;
  enableAssignmentAnalyticsItemLevel: boolean;
  enableCBAddAssessments: boolean;
  enableCBCourseReuseAssessments: boolean;
  enableReviewSubmissionScreenForAutoGradedQuestions: boolean;
  enableRetryAsmntFromFeedbackPage: boolean;
  enableNextGenAssignmentsQuestionByQuestion: boolean;
  nextGenAssignmentsQuestionByQuestionRolloutConfig: any;
  enableMasteryLevels: boolean;
  enableNextGenAssignmentsPhase1AAExclusionTest: boolean;
  enableGeneratedCodingPracticeTest1: boolean;
  generatedCodingPracticeTest1Config: any;
  'enableNextGenAssignmentsQuestionByQuestion_90-10': boolean;
};

const NAMESPACE = 'Assignments';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([Assignments as $TSFixMe]);

const AssignmentsEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default AssignmentsEpicClient;
